import { render, staticRenderFns } from "./claimsGuide.vue?vue&type=template&id=19dbb40c&scoped=true"
import script from "./claimsGuide.vue?vue&type=script&lang=js"
export * from "./claimsGuide.vue?vue&type=script&lang=js"
import style0 from "./claimsGuide.vue?vue&type=style&index=0&id=19dbb40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dbb40c",
  null
  
)

export default component.exports